import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { updateFilterItems } from '@utils/utils';
import { filterTypesKey, I_FilterItem, priceType } from '@Redux/search/interfaces';
import { setFilterItems, setChangeItem } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import { ArrowUp } from '@components/Common/Icons/index';
import PriceRangeItem from './PriceRangeItem';
import CheckboxItem from './CheckboxItem';

interface FilterBlockProps {
    cols: number;
    title: string;
    filterType: string;
    options: { [keys: string]: any[] };
    data_cy: string;
}

const FilterBlock: React.FC<FilterBlockProps> = (props) => {
    const moduleName = 'filterBlock';
    const { cols, title, filterType, options } = props;
    const [open, setOpen] = useState<boolean>(true);
    const dispatch = useDispatch();
    const { FilterItems } = useSelector((state: RootState) => state.search);

    const renderCheckBoxs = () => {
        return (
            <ul className={cN(styles.CheckBoxes)} data-cy={props.data_cy}>
                {options[filterType].map((opt) => {
                    const clickedValText = (() => {
                        const newOpt = {
                            text: '',
                            value: '',
                        };
                        switch (filterType) {
                            case filterTypesKey.DepartureList:
                                newOpt.text = opt.CityName;
                                newOpt.value = opt.CityCode;
                                break;
                            case filterTypesKey.TravelType:
                            case filterTypesKey.DayList:
                                newOpt.text = opt.Text;
                                newOpt.value = opt.Value;
                                break;
                            case filterTypesKey.WeekDays:
                                newOpt.text = `星期${opt.Text}`;
                                newOpt.value = opt.Value;
                                break;
                            case filterTypesKey.AirlineList:
                                newOpt.text = opt.AirlineName;
                                newOpt.value = opt.AirlineID;
                                break;
                            case filterTypesKey.BuList:
                                newOpt.text = opt.Name;
                                newOpt.value = opt.ID;
                                break;
                            default:
                                return newOpt;
                        }
                        return newOpt;
                    })();
                    const checkprops = {
                        text: clickedValText.text,
                        value: clickedValText.value,
                        note: opt.note,
                        filterType: filterType,
                        isDisable: false,
                    };

                    return (
                        <CheckboxItem
                            key={`${clickedValText.value}${clickedValText.text}`}
                            cols={`col${cols}`}
                            {...checkprops}
                        />
                    );
                })}
            </ul>
        );
    };

    const defaultPriceVal = (min: number, max: number) => {
        if (FilterItems.length === 0) {
            return [min, max];
        } else {
            const filterMin = FilterItems.filter(
                (item: I_FilterItem) => item.subValue === priceType.min
            );
            const filterMax = FilterItems.filter(
                (item: I_FilterItem) => item.subValue === priceType.max
            );
            return [filterMin[0]?.value || min, filterMax[0]?.value || max];
        }
    };

    const handleMouseUpChange = (value: number[], onDragBtn: string) => {
        const min = value[0];
        const max = value[1];
        if (max === 0) return;
        const minText = `≧ TWD${value[0].toString()}`;
        const maxText = `≦ TWD${value[1].toString()}`;
        const isMin = onDragBtn === priceType.min;
        const props = {
            data: FilterItems,
            nowType: filterType,
            value: isMin ? min : max,
            text: isMin ? minText : maxText,
            subValue: onDragBtn,
            priceDefaultRange: [
                options[filterTypesKey.PriceRange][0].PriceStart,
                options[filterTypesKey.PriceRange][0].PriceEnd,
            ],
        };
        const newFilterItems = updateFilterItems(props);
        dispatch(setFilterItems(newFilterItems));
        dispatch(setChangeItem(true));
    };

    return (
        <li className={styles[`${moduleName}`]}>
            <div
                className={cN(styles.Block_title)}
                onClick={() => {
                    setOpen(!open);
                }}
            >
                <div className={cN(styles.Title)}>{title}</div>
                <div className={cN(styles.Icon, { up: open, down: !open })}>
                    <ArrowUp />
                </div>
            </div>
            <div className={cN(styles.Block_content, { show: open })}>
                {filterType === filterTypesKey.PriceRange ? (
                    <PriceRangeItem
                        Currency="TWD"
                        minPrice={options[filterTypesKey.PriceRange][0].PriceStart}
                        maxPrice={options[filterTypesKey.PriceRange][0].PriceEnd}
                        setRange={defaultPriceVal(
                            options[filterTypesKey.PriceRange][0].PriceStart,
                            options[filterTypesKey.PriceRange][0].PriceEnd
                        )}
                        mouseupChange={(value: number[], onDragBtn: string) => {
                            handleMouseUpChange(value, onDragBtn);
                        }}
                    />
                ) : (
                    renderCheckBoxs()
                )}
            </div>
        </li>
    );
};

export default FilterBlock;
